import type { AppContext } from "../types";
import type { Session } from "../types/session";
import { loadSession } from "../api";

export interface SessionManagerAPI {
  readonly getSession: () => Readonly<Session | null>;
  readonly refresh: () => Promise<Session | null>;
  readonly clear: () => void;
  readonly setSession: (next: Session | null) => void;
  readonly destroy: () => void;
}

export const createSessionManager = (
  appContext: AppContext
): SessionManagerAPI => {
  let session: Session | null = null;

  const getSession = (): Readonly<Session | null> =>
    session ? { ...session } : null;

  const setSession = (next: Session | null) => {
    session = next;
    appContext.eventBus.emit("session:updated", { session });
  };

  const refresh = async (): Promise<Session | null> => {
    try {
      const s = await loadSession();
      setSession(s);
      return s;
    } catch (e) {
      setSession(null);
      return null;
    }
  };

  const clear = () => setSession(null);

  const destroy = () => {
    session = null;
  };

  return { getSession, refresh, clear, setSession, destroy };
};
